import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../Navbar";
import "./Dashboard.css";
import About from "../DashboardComponents/About";
import Generator from "../DashboardComponents/Generator";
import MyReport from "../DashboardComponents/MyReport";
import DashboardButtons from "../ButtonComponents/DashboardButtons";
import axios from "axios";

const Dashboard = () => {

  const [activeComponent, setActiveComponent] = useState("about");
  const navigate = useNavigate();

  const [isSidebarOpen, setisSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setisSidebarOpen((prev) => !prev);
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;



  useEffect(() => {
    const userExist = localStorage.getItem("UserId");
    if (!userExist) {
      navigate("/");
    }
  }, [navigate]);

  const handleLogout = async () => {
    try {
      const response = await axios.post(`${baseUrl}api/user/logout`, {
        SessionId: String(localStorage.getItem("SessionId")),
      });
      if (response.status === 200 && response.data.isSucess) {
        alert(response.data.message);
        localStorage.removeItem("UserId");
        localStorage.removeItem("SessionId");
        navigate("/");
      } else {
        alert(response.data.message || "Failed to log out");
      }
    } catch (error) {
      console.error("Error logging out:", error);
      alert("An error occurred while logging out");
    }
  };

  const renderComponent = () => {
    switch (activeComponent) {
      case "about":
        return <About />;
      case "generator":
        return <Generator />;
      case "myreport":
        return <MyReport />;
      default:
        return <About />;
    }
  };

  // const toggleSidebar = () => {
  //   setIsSidebarOpen((prevState) => !prevState);
  // };

  return (
    <div><Navbar/>
      {/* Dashboard Layout */}
      <div className="d-flex" style={{ overflow: "hidden" }}>
        {/* Sidebar */}
        {/* {isSidebarOpen && (
          <div
            className="sidebar text-white d-flex flex-column justify-content-between p-3 fixed-left"
            style={{
              width: "250px",
              height: "100vh",
              position: "fixed",
              background: "#14213D",
              zIndex: 1050, // Ensure it overlays main content
              transition: "transform 0.3s ease-in-out",
              transform: isSidebarOpen ? "translateX(0)" : "translateX(-100%)",
            }}
          >
            <div>
              <h3 className="text-center">Dashboard</h3>
              <div className="mb-3 text-center">
                <DashboardButtons
                  label="About"
                  onClick={() => setActiveComponent("about")}
                />
              </div>
              <div className="mb-3 text-center">
                <DashboardButtons
                  label="Generate"
                  onClick={() => setActiveComponent("generator")}
                />
              </div>
              <div className="mb-5 text-center">
                <DashboardButtons
                  label="My Reports"
                  onClick={() => setActiveComponent("myreport")}
                />
              </div>
            </div>
            <div className="mb-5 text-center">
              <DashboardButtons label="Logout" onClick={handleLogout} />
            </div>
          </div>
        )} */}

        <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
          <div className="logo-details">
            {/* <i className="bx bxl-c-plus-plus icon"></i> */}
            <i class='bx bxs-dashboard icon' style={{color:'#181c14'}} ></i>
            <div className="logo_name">Dashboard</div>    
            <i
              className={`bx ${isSidebarOpen ? "bx-menu-alt-right" : "bx bx-sidebar"}`}
              style={{color:'#181c14'}}
              id="btn"
              onClick={toggleSidebar}
            ></i>
            
          </div>
          <ul className="nav-list">
            <li>
              <a onClick={() => setActiveComponent("generator")}>
                <i className="bx bx-grid-alt"></i>
                <span className="links_name" onClick={() => setActiveComponent("generator")}>Generate</span>
              </a>
              <span className="tooltip">Generate</span>
            </li>
            <li>
              <a onClick={() => setActiveComponent("myreport")}>
                <i className="bx bx-user"></i>
                <span className="links_name" >My Reports</span>
              </a>
              <span className="tooltip">My Reports</span>
            </li>
            <li>
              <a onClick={handleLogout}>
              <i className='bx bx-log-out'></i>
                <span className="links_name" >Logout</span>
              </a>
              <span className="tooltip">Logout</span>
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div
          style={{
            marginLeft: isSidebarOpen ? "250px" : "80px",
            marginTop: "75px",
            padding: "20px",
            width: isSidebarOpen ? "calc(100% - 250px)" : "100%",
            height: "100%",
            overflowY: "auto",
            transition: 'all 0.5s ease'
          }}
        >
          {renderComponent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
